export class BatchResourceValidationResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "isValid",
            "baseName": "isValid",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "errors",
            "baseName": "errors",
            "type": "Array<ResourceValidationError>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BatchResourceValidationResult.attributeTypeMap;
    }
    constructor() {
    }
}
